import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import {withRouter} from "react-router-dom";
import { getIdFromSlug, urlSlug } from '~/common';

const baseClassName = (notification) => `notification-${notification}`;

@withRouter
@inject('appStore', 'dictStore', 'lineStore')
@observer
class MovingStatistics extends Component {
  closeNotification = () => {
    this.props.appStore.setNotificationVisibility('movingStatistics', false);
  };

  redirectToMainMatch = () => {
    this.closeNotification();
    
    const { match, history } = this.props;
    const { mode: active } = this.props.lineStore.basket;
    const dictionary = this.props.lineStore.menu.dict.eng;
		
    const sportId = getIdFromSlug(match.params.sport);
    const pathnameSport = /^[0-9]*$/.test(sportId)
      ? sportId
      : urlSlug(sportId, dictionary && dictionary.sport[sportId]);

    const gameId = getIdFromSlug(match.params.games);
    const game = this.props.lineStore['line'].lineGames.get(Number(gameId));
    const mainGameId = game && game.parent_game_id;
    const mainLeagueId = game && game.parent_league_id;
    const pathnameLeague = urlSlug(mainLeagueId, dictionary && dictionary.league[mainLeagueId] || mainLeagueId);

    if (mainLeagueId && mainGameId) {
      history.push(`/${active}/${pathnameSport}/${pathnameLeague}/${mainGameId}`);
    }
  };

  render() {
    if (this.props.redirect) {
      this.redirectToMainMatch();
    }

    if (!(this.props.appStore.isNotificationVisible && this.props.appStore.isNotificationVisible.movingStatistics)) {
      return null;
    }

    const {
      dictStore: { getLang },
    } = this.props;

    return (
      <div className={baseClassName('moving-stats')}>
        <button
          type="button"
          onClick={this.closeNotification}
          className={baseClassName('moving-stats-close')}
        />

        <div className={baseClassName('moving-stats-top')}>
          <img
            className={baseClassName('moving-stats-top-icon')}
            src="/assets/img/warningMovingStatistics.png"
            alt=""
          />
          <div className={baseClassName('moving-stats-top-title')}>
            {getLang('BET_STATISTICS_MOVE')}
          </div>
        </div>

        <div className={baseClassName('moving-stats-content')}>
          <p>{getLang('ALL_STATISTICS_GROUP_BREAK')}</p>
          <p>{getLang('CURRENT_STATISTIC_FORMAT_WILL_OFF')}</p>
        </div>

        <button
          type="button"
          className={baseClassName('moving-stats-button')}
          onClick={this.redirectToMainMatch}
        >
          {getLang('MOVE_ON')}
        </button>
      </div>
    );
  }
}

export default MovingStatistics;


// WEBPACK FOOTER //
// ./src/components/movingStatistics/index.jsx